import { Link } from "react-router-dom";
import { ArrowRight, Mail, MapPin, Phone } from "lucide-react";
import { ASSETS, CONTACT } from "@/data/site";
import { Reveal } from "@/components/Reveal";
import WhatsAppCTA from "@/components/WhatsAppCTA";

export default function ContactBand() {
  return (
    <section data-testid="contact-band" className="bg-taupe py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 sm:px-12 lg:grid-cols-2 lg:px-20">
        <div>
          <Reveal>
            <div className="flex items-center gap-4">
              <span className="hairline" />
              <span className="eyebrow">Project Enquiry</span>
            </div>
            <h2 className="mt-5 font-serif text-3xl font-medium leading-tight tracking-tight text-stone-900 sm:text-5xl">
              Have a Space in Mind?
              <span className="gold-grad-text block italic">Let's Create It in Stone.</span>
            </h2>
            <p className="mt-3 font-script text-2xl text-gold-dark/80 sm:text-3xl">
              Spaces That Last a Lifetime
            </p>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-stone-600">
              Tell us about your project, idea or requirement. Our team can develop a bespoke stone
              concept for residential, hospitality, corporate, architectural or gifting applications.
            </p>
            <div className="mt-9 flex flex-wrap gap-4">
              <WhatsAppCTA
                label="Start a Project"
                message="Hello ShilpStones Creations, I have a space in mind and would like to start a project discussion."
                context="Contact band — Start a Project"
                testId="contact-start-project-button"
              />
              <a
                href={`tel:${CONTACT.phones[0].tel}`}
                data-testid="contact-call-button"
                className="inline-flex items-center gap-2.5 rounded-full border border-stone-900/25 px-7 py-3.5 text-xs font-semibold uppercase tracking-[0.18em] text-stone-800 transition-all duration-300 hover:-translate-y-0.5 hover:border-gold hover:text-gold-dark"
              >
                <Phone className="h-4 w-4" />
                {CONTACT.phones[0].label}
              </a>
            </div>
            <div className="mt-10 space-y-3 text-sm text-stone-600">
              {CONTACT.addresses.map((a) => (
                <p key={a.label} className="flex items-center gap-2.5">
                  <MapPin className="h-4 w-4 shrink-0 text-gold-dark" />
                  {a.value}
                </p>
              ))}
              <p className="flex items-center gap-2.5">
                <Mail className="h-4 w-4 shrink-0 text-gold-dark" />
                <a href={`mailto:${CONTACT.email}`} className="transition-colors hover:text-gold-dark">
                  {CONTACT.email}
                </a>
              </p>
            </div>
            <Link
              to="/contact"
              data-testid="contact-band-details-link"
              className="group mt-8 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-gold-dark transition-colors hover:text-gold"
            >
              Full Contact Details
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
            </Link>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <div className="spotlight-frame overflow-hidden rounded-2xl">
            <img
              src={ASSETS.office}
              alt="ShilpStones executive office with marble desk"
              loading="lazy"
              className="aspect-[4/3] w-full object-cover"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
